import { createFileRoute } from '@tanstack/react-router';
import { MasterOrganizationsPage } from '@/pages/master-management/ui/MasterOrganizationsPage';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

export const Route = createFileRoute('/_protected/master/organizations')({
  component: MasterOrganizationsPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: paginationSchema,
      defaultValues: undefined,
    }),
});
